import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type { LootboxBonus } from '@/api/common';
import { IconComponent } from '@/components/IconComponent';
import { formatLootboxItemTitle } from '@/modules/promotions/helpers/fortuneWheel';
import { useLootboxBonus } from '@/modules/promotions/hooks';
import { ScTermsButton } from '../../../DiceRollPage/components/PrizeBlock/styled';
import { ScScratchBonusTerms } from './styled';

interface IScratchBonusTerms {
  bonus: LootboxBonus | null;
}

export const ScratchBonusTerms: FC<IScratchBonusTerms> = ({ bonus }) => {
  const { t } = useTranslation('wheel');

  const [isOpenTerms, setIsOpenTerms] = useState(false);

  const { bonusAmount, maxWin, wager, title } = useLootboxBonus(bonus);

  return (
    <ScScratchBonusTerms isOpen={isOpenTerms}>
      <div className="btn_wrapper">
        <ScTermsButton
          isOpen={isOpenTerms}
          onClick={() => setIsOpenTerms(!isOpenTerms)}
        >
          <span>{t('common:button.termsAndConditions')}</span>
          <IconComponent name="whiteArrowRight" size="18px" />
        </ScTermsButton>
      </div>

      <div className="content-box">
        <div className="content">
          <p className="bonus">
            {t('termsAndConditions.bonus', {
              bonus: formatLootboxItemTitle(title),
            })}
          </p>
          <p>{t('termsAndConditions.expiresIn')}</p>
          <p>{t('termsAndConditions.wager', { wager })}</p>
          {bonusAmount && (
            <p>{t('termsAndConditions.maxBonus', { bonusAmount })}</p>
          )}
          {maxWin && <p>{t('termsAndConditions.maxWin', { maxWin })}</p>}
        </div>
      </div>
    </ScScratchBonusTerms>
  );
};
